import * as React from 'react'
import styled from 'styled-components'

import { useFilters } from '~/hooks/use-filters'

import { Content } from './components/content/content'
import { Header } from './components/header'

export interface FiltersProps {
  className?: string
  children?: React.ReactNode
}

const StyledContainer = styled.aside`
  background: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  z-index: 100;
`

export function Filters(props: FiltersProps) {
  const { className, children } = props

  const { productFilters } = useFilters()

  return (
    <StyledContainer className={className}>
      <Header />
      <Content productFilters={productFilters} />
      {children}
    </StyledContainer>
  )
}
